import {
  allowedReasonCode,
  allowedReasonText,
  allowedResponseCode,
} from "../../utils/utils";
export const addAgreement = (agreement) => {
  return (dispatch, getState, { getFirebase, getFirestore }) => {
    const firestore = getFirestore();
    const firebase = getFirebase();
    const agreementRef = firestore
      .collection("testAgreements")
      .doc(agreement.agreementId);
    const batch = firestore.batch();
    const toFirestore = {
      agreementId: agreement.agreementId,
      fileName: agreement.fileName,
      type: agreement.type,
      show: agreement.show,
      createdAt: firebase.firestore.Timestamp.fromDate(new Date()),
    };
    batch.set(agreementRef, toFirestore, { merge: true });
    batch
      .commit()
      .then(() => {
        const storageRef = firebase.storage().ref();
        const uploadRef = storageRef
          .child("agreements")
          .child("files")
          .child(agreement.agreementId)
          .child("PDFs")
          .child(agreement.fileName);

        return uploadRef.put(agreement.file).on(
          "state_changed",
          (snapshot) => {
            let progress =
              (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
            dispatch({
              type: "ADD_SKILL_PROGRESS",
              value: progress,
              media: "PDF",
            });
          },
          (error) => {
            dispatch({ type: "ADD_SKILL_ERROR", error });
          },
          () => {
            uploadRef
              .getDownloadURL()
              .then(function (downloadURL) {
                const skillThumbnail = {
                  fileUrl: downloadURL,
                };

                const batch = firestore.batch();
                batch.update(agreementRef, skillThumbnail);

                batch
                  .commit()
                  .then(() => {
                    dispatch({ type: "ADD_SKILL_SUCCESS" });
                  })
                  .catch((err) => {
                    dispatch({ type: "ADD_SKILL_ERROR", err });
                  });
              })
              .catch((err) => {
                dispatch({ type: "ADD_SKILL_ERROR", err });
              });
          }
        );
      })
      .catch((err) => {});
  };
};

export const handleAgreementShow = (id, status) => {
  return (dispatch, getState, { getFirebase, getFirestore }) => {
    const firestore = getFirestore();
    const eventsRef = firestore.collection("testAgreements").doc(id);
    const batch = firestore.batch();
    const toFirestore = { show: status };
    batch.set(eventsRef, toFirestore, { merge: true });
    batch
      .commit()
      .then()
      .catch((err) => {});
  };
};

export const deleteAgreement = (id) => {
  return (dispatch, getState, { getFirebase, getFirestore }) => {
    const firestore = getFirestore();
    const eventsRef = firestore.collection("testAgreements").doc(id);
    eventsRef.delete();
  };
};

export const newSignupRequest = (data) => {
  return (dispatch, getState, { getFirebase, getFirestore }) => {
    const firebase = getFirebase();
    const firestore = getFirestore();
    const eventsRef = firestore.collection("testNewRequests").doc(data.id);
    const batch = firestore.batch();

    const toFirestore = {
      ...data,
      modifiedAt: firebase.firestore.Timestamp.fromDate(new Date()),
    };
    batch.set(eventsRef, toFirestore, { merge: true });
    batch
      .commit()
      .then(() => {
        dispatch({ type: "ADD_SKILL_SUCCESS" });
      })
      .catch((err) => {
        dispatch({ type: "ADD_SKILL_ERROR", err });
      });
  };
};

export const addMainAgreement = (agreement) => {
  return (dispatch, getState, { getFirebase, getFirestore }) => {
    const firestore = getFirestore();
    const firebase = getFirebase();
    const agreementRef = firestore
      .collection("testNewRequests")
      .doc(agreement.UserId);
    const batch = firestore.batch();
    const toFirestore = {
      modifiedAt: firebase.firestore.Timestamp.fromDate(new Date()),
    };
    batch.set(agreementRef, toFirestore, { merge: true });
    batch
      .commit()
      .then(() => {
        const storageRef = firebase.storage().ref();
        const uploadRef = storageRef
          .child("testUserAgreements")
          .child("files")
          .child(agreement.UserId)
          .child("PDFs")
          .child(`mainAgreement`);

        return uploadRef.put(agreement.file).on(
          "state_changed",
          (snapshot) => {
            let progress =
              (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
            dispatch({
              type: "MAIN_AGREEMENT_UPLOAD",
              value: progress,
              media: "PDF",
            });
          },
          (error) => {
            dispatch({ type: "MAIN_AGREEMENT_ERROR", error });
          },
          () => {
            uploadRef
              .getDownloadURL()
              .then(function (downloadURL) {
                const skillThumbnail = {
                  mainAgreementUrl: downloadURL,
                };

                const batch = firestore.batch();
                batch.update(agreementRef, skillThumbnail);

                batch
                  .commit()
                  .then(() => {
                    dispatch({ type: "MAIN_AGREEMENT_SUCESS" });
                  })
                  .catch((err) => {
                    dispatch({ type: "MAIN_AGREEMENT_ERROR", err });
                  });
              })
              .catch((err) => {
                dispatch({ type: "MAIN_AGREEMENT_ERROR", err });
              });
          }
        );
      })
      .catch((err) => {
        dispatch({ type: "MAIN_AGREEMENT_ERROR", err });
      });
  };
};
export const addsecondAgreement = (agreement) => {
  return (dispatch, getState, { getFirebase, getFirestore }) => {
    const firestore = getFirestore();
    const firebase = getFirebase();
    const agreementRef = firestore
      .collection("testNewRequests")
      .doc(agreement.UserId);
    const batch = firestore.batch();
    const toFirestore = {
      customerType: agreement.customerType,
      modifiedAt: firebase.firestore.Timestamp.fromDate(new Date()),
    };
    batch.set(agreementRef, toFirestore, { merge: true });
    dispatch({ type: "SECOND_AGREEMENT_UPLOAD" });
    batch
      .commit()
      .then(() => {
        const storageRef = firebase.storage().ref();
        const uploadRef = storageRef
          .child("testUserAgreements")
          .child("files")
          .child(agreement.UserId)
          .child("PDFs")
          .child("secondAgreement");

        return uploadRef.put(agreement.file).on(
          "state_changed",
          (snapshot) => {
            dispatch({ type: "SECOND_AGREEMENT_UPLOAD" });
          },
          (error) => {
            dispatch({ type: "SECOND_AGREEMENT_ERROR", error });
          },
          () => {
            uploadRef
              .getDownloadURL()
              .then(function (downloadURL) {
                const skillThumbnail = {
                  secondAgreementUrl: downloadURL,
                };

                const batch = firestore.batch();
                batch.update(agreementRef, skillThumbnail);

                batch
                  .commit()
                  .then(() => {
                    dispatch({ type: "SECOND_AGREEMENT_SUCESS" });
                    dispatch({ type: "SECOND_AGREEMENT_CLEARSTATUS" });
                  })
                  .catch((err) => {
                    dispatch({ type: "SECOND_AGREEMENT_ERROR", err });
                  });
              })
              .catch((err) => {
                dispatch({ type: "SECOND_AGREEMENT_ERROR", err });
              });
          }
        );
      })
      .catch((err) => {
        dispatch({ type: "SECOND_AGREEMENT_ERROR", err });
      });
  };
};
export const selectPlan = (planId, userId) => {
  return (dispatch, getState, { getFirebase, getFirestore }) => {
    const firestore = getFirestore();
    const firebase = getFirebase();
    const agreementRef = firestore.collection("testNewRequests").doc(userId);
    const batch = firestore.batch();
    const toFirestore = {
      selectedPlan: `${planId}`,
      modifiedAt: firebase.firestore.Timestamp.fromDate(new Date()),
    };
    batch.set(agreementRef, toFirestore, { merge: true });
    batch
      .commit()
      .then(() => {})
      .catch((err) => {
        dispatch({ type: "MAIN_AGREEMENT_ERROR", err });
      });
  };
};

export const getPaymentDetails = (paymentDetails, userId) => {
  return (dispatch, getState, { getFirebase, getFirestore }) => {
    dispatch({ type: "PAYMENT_DETAILS_ADD" });
    const firestore = getFirestore();
    const firebase = getFirebase();
    const agreementRef = firestore.collection("testNewRequests").doc(userId);
    const batch = firestore.batch();
    const toFirestore = {
      ...paymentDetails,
      modifiedAt: firebase.firestore.Timestamp.fromDate(new Date()),
    };
    batch.set(agreementRef, toFirestore, { merge: true });
    batch
      .commit()
      .then(() => {
        dispatch({ type: "PAYMENT_DETAILS_SUCCESS" });
        dispatch({ type: "PAYMENT_DETAILS_CLEAR_STATUS" });
      })
      .catch((err) => {
        dispatch({ type: "PAYMENT_DETAILS_ERROR", err });
      });
  };
};

export const getPayment = (paymentDetails) => {
  return (dispatch, getState, { getFirebase, getFirestore }) => {
    const firebase = getFirebase();
    const firestore = getFirestore();
    // Remove This Line Before Deployment
    // firebase.functions().useEmulator("localhost", 5001);
    const agreementRef = firestore
      .collection("testNewRequests")
      .doc(paymentDetails.userId);
    const epicPaymentInitiate = firebase
      .functions()
      .httpsCallable("paymentInitiate");

    dispatch({ type: "PAYMENT_HAPPENING" });
    epicPaymentInitiate(paymentDetails)
      .then((res) => {
        const { data } = res;
        console.log(data);
        if (res.data.error) {
          dispatch({
            type: "PAYMENT_ERROR",
            err: "Something Went Wrong Try Again Later",
          });
        } else {
          const response = data?.response;
          const response_code = data?.response_code;
          const responsetext = data?.responsetext;
          const transactionid = data?.transactionid;
          const subscription_id = data?.subscription_id;
          const type = data?.type;

          if (
            response === "1" &&
            response_code === "100" &&
            responsetext === "SUCCESS" &&
            type === "sale" &&
            !subscription_id
          ) {
            const toFirestore = {
              // Emptying credit card data Upon Successfull transaction
              card_number: null,
              card_holder_name: null,
              exp_month: null,
              exp_year: null,
              cvv: null,
              // Emptying eCheck data Upon Successfull transaction
              accountHolderName: null,
              accountNumber: null,
              accountType: null,
              routingNumber: null,

              // Emptying getting transaction data Upon Successfull transaction
              transaction_id: transactionid || null,

              subscription_id: null,
              paymentDone: true,
              refund: false,
              status: null,
              modifiedAt: firebase.firestore.Timestamp.fromDate(new Date()),
            };
            const batch = firestore.batch();
            batch.set(agreementRef, toFirestore, { merge: true });
            batch.commit().then(() => {
              dispatch({ type: "PAYMENT_DONE" });
            });
            dispatch({ type: "PAYMENT_CLEAR_STATUS" });
          } else if (
            response === "1" &&
            response_code === "100" &&
            responsetext === "Subscription added" &&
            type === "" &&
            subscription_id
          ) {
            const toFirestore = {
              // Emptying credit card data Upon Successfull transaction
              card_number: null,
              card_holder_name: null,
              exp_month: null,
              exp_year: null,
              cvv: null,
              // Emptying eCheck data Upon Successfull transaction
              accountHolderName: null,
              accountNumber: null,
              accountType: null,
              routingNumber: null,
              // Emptying getting transaction data Upon Successfull transaction
              transaction_id: transactionid || null,
              subscription_id: subscription_id || null,
              paymentDone: true,
              refund: false,
              status: null,
              modifiedAt: firebase.firestore.Timestamp.fromDate(new Date()),
            };
            const batch = firestore.batch();
            batch.set(agreementRef, toFirestore, { merge: true });
            batch.commit().then(() => {
              dispatch({ type: "PAYMENT_DONE" });
            });
            dispatch({ type: "PAYMENT_CLEAR_STATUS" });
          } else {
            dispatch({
              type: "PAYMENT_ERROR",
              err: responsetext,
            });
          }
        }
      })
      .catch((e) => {});
  };
};

export const handleNewUser = (data) => {
  let email;
  let password;
  let userUID;
  let newRequestRef;
  let roleRef;
  return (dispatch, getState, { getFirebase, getFirestore }) => {
    const firestore = getFirestore();
    const firebase = getFirebase();
    const batch = firestore.batch();
    const currentTime = firebase.firestore.Timestamp.fromDate(new Date());
    const createUser = firebase.functions().httpsCallable("createUser");
    const role = { role: "newUser", createdAt: currentTime };

    password = data.password;
    email = data.email;
    dispatch({ type: "SIGNUP_ADDING" });
    createUser({ email, password })
      .then(({ data: user }) => {
        dispatch({ type: "SIGNUP_ADD_SUCCESS" });
        userUID = user.uid;
        roleRef = firestore.collection("userRole").doc(user.uid);
        newRequestRef = firestore.collection("testNewRequests").doc(user.uid);
        const toFirestore = {
          email,
          id: userUID,
          fname: data.fname,
          lname: data.lname,
          createdAt: currentTime,
          modifiedAt: currentTime,
        };
        batch.set(newRequestRef, toFirestore, { merge: true });
        batch.set(roleRef, { ...role, userUID }, { merge: true });

        batch
          .commit()
          .then(() => {
            firebase
              .auth()
              .signInWithEmailAndPassword(email, password)
              .then(() => {
                dispatch({ type: "LOGIN_SUCCESS" });
                dispatch({ type: "SIGNUP_DETAILS_CLEAR_STATUS" });
                firebase.auth().currentUser.sendEmailVerification();
              })
              .catch((err) => {
                dispatch({ type: "LOGIN_ERROR", err });
              });
          })
          .catch((error) => {
            console.error("Error writing document: ", error);
          });
      })
      .catch((error) => dispatch({ type: "SIGNUP_ADD_ERROR", error }));
  };
};

export const resendVerfication = () => {
  return (dispatch, getState, { getFirebase, getFirestore }) => {
    dispatch({ type: "LINK_SENDING" });
    const firebase = getFirebase();
    firebase
      .auth()
      .currentUser.sendEmailVerification()
      .then(() => {
        dispatch({ type: "LINK_SENT" });
        setTimeout(() => {
          dispatch({ type: "LINK_SEND_CLEAR_STATUS" });
        }, 60000);
      })
      .catch((err) => {
        dispatch({ type: "LINK_SEND_ERROR", err });
        setTimeout(() => {
          dispatch({ type: "LINK_SEND_CLEAR_STATUS" });
        }, 60000);
      });
  };
};
